module.exports = __webpack_public_path__ + "static/img/mt.097c1fd3.png";